import createIcon from '../../createIcon';

/**
 * @component @name Camera
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS40IDEwLjVMMTQuMTcgMi4yNEMxMy40NyAyLjA5IDEyLjc1IDIgMTIgMkM5LjYgMiA3LjQgMi44NSA1LjY4IDQuMjVMOS4zNCAxMC42TDkuNCAxMC41Wk0yMS41NCA5QzIwLjYyIDYuMDggMTguMzkgMy43NCAxNS41NCAyLjY2TDExLjg4IDlIMjEuNTRaTTIxLjggMTBIMTQuMzFMMTQuNiAxMC41TDE5LjM2IDE4Ljc1QzIxIDE2Ljk3IDIyIDE0LjYxIDIyIDEyQzIyIDExLjMxIDIxLjkzIDEwLjY1IDIxLjggMTBaTTguNTQgMTJMNC42NCA1LjI1QzMuMDEgNy4wMyAyIDkuMzkgMiAxMkMyIDEyLjY5IDIuMDcgMTMuMzUgMi4yIDE0SDkuNjlMOC41NCAxMlpNMi40NiAxNUMzLjM4IDE3LjkyIDUuNjEgMjAuMjYgOC40NiAyMS4zNEwxMi4xMiAxNUgyLjQ2Wk0xMy43MyAxNUw5LjgzIDIxLjc2QzEwLjUzIDIxLjkxIDExLjI1IDIyIDEyIDIyQzE0LjQgMjIgMTYuNiAyMS4xNSAxOC4zMiAxOS43NUwxNC42NiAxMy40TDEzLjczIDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Camera = createIcon('Camera', [
  [
    'path',
    {
      d: 'M9.4 10.5L14.17 2.24C13.47 2.09 12.75 2 12 2C9.6 2 7.4 2.85 5.68 4.25L9.34 10.6L9.4 10.5ZM21.54 9C20.62 6.08 18.39 3.74 15.54 2.66L11.88 9H21.54ZM21.8 10H14.31L14.6 10.5L19.36 18.75C21 16.97 22 14.61 22 12C22 11.31 21.93 10.65 21.8 10ZM8.54 12L4.64 5.25C3.01 7.03 2 9.39 2 12C2 12.69 2.07 13.35 2.2 14H9.69L8.54 12ZM2.46 15C3.38 17.92 5.61 20.26 8.46 21.34L12.12 15H2.46ZM13.73 15L9.83 21.76C10.53 21.91 11.25 22 12 22C14.4 22 16.6 21.15 18.32 19.75L14.66 13.4L13.73 15Z',
      key: '1otlt1',
    },
  ],
]);

export default Camera;
